/** Mint an MCP token (block 27). The result is the only time its connector link is visible. */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getNookClient } from "../client.js";
import { queryKeys } from "../query-keys.js";
export function useCreateMcpToken() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (name) => getNookClient().createMcpToken(name),
        onSettled() {
            void queryClient.invalidateQueries({ queryKey: queryKeys.mcpTokens.all() });
        },
    });
}
//# sourceMappingURL=use-create-mcp-token.js.map